<template>
  <div class="expandtofill">
        <!-- // * CONTENT TITLE (GENERIC) -->
        <v-row class="grey lighten-2 white--text pl-4 pr-2 d-flex align-center white">
            <v-col cols="1">
                <app-text category="content-title">
                    <div class="d-flex align-center">
                        <span class="pl-2">{{ $t(`${langPath}.new`) }}</span>
                    </div>
                </app-text>
            </v-col>
            <v-spacer></v-spacer>

            <v-col cols="4" class="text-right d-flex align-center">           
                <!-- <v-select :label="$t(`fields.type`)" v-model="form.id" :items="guides" dense filled hide-details :background-color="formBackground" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }">
                    <template v-slot:item="data">
                        {{ data.item }}
                    </template>
                    <template v-slot:selection="data">
                        {{ data.item }}
                    </template>
                </v-select> -->
                <appbutton :label="$t('buttons.edit')" v-if="formMode === 'View'" icon="icons8-edit-property" type="secondary"  class="ml-3" @click.native="formMode = 'Edit'" />
                <appbutton :label="$t('buttons.save')" v-if="formMode === 'New' || formMode === 'Edit'" icon="icons8-edit-property" type="secondary"  class="ml-3" @click.native="saveItem()" />
            </v-col>
        </v-row>
        <v-divider class="grey lighten-1"></v-divider>
        <v-row>
            <v-container fluid class="pa-4"  >
                <v-row no-gutters class="">
                    <v-col cols="12" class="px-5">
                        <vue-editor v-model="form.content" v-if="formMode === 'New' || formMode === 'Edit'"></vue-editor>
                        <div v-html="form.content" v-if="formMode === 'View'"></div>
                    </v-col>
                </v-row>
            </v-container>
        </v-row>
        <v-row>
            <v-col cols="12">
                <!-- <pre>{{ form }}</pre> -->
            </v-col>
        </v-row>
  
  </div>
</template>

<script>
    import { VueEditor } from "vue2-editor";
    export default {
      components: {
        VueEditor
      },

      data: () => ({
                // * PAGE DETAILS
                collection: 'guides',
                collectionTitle: 'Guides',
                collectionItem: 'guides',
                collectionItemTitle: 'Guide',
                langPath: 'guides',
                form: {
                    id: '',
                    content: ''
                },
                formMode: 'View',
                formReadOnly: false,
                formBackground: 'white',
                content: "<h1>Some initial content</h1>",
                editMode: false,
                guides: ['project', 'document']
        }),
        methods: {
            // SAVE ITEM
            saveItem: async function() {
                var t = this;
                if (t.form.id === undefined) {
                    t.form.id = t.MIX_generateId();  // if new then generate new id
                }                
                var createDocumentResult = await t.MIX_createDocument(t.collection, t.form); // Create Document Within Firestore based on Form
                if (createDocumentResult.code === 1) {
                    t.MIX_alert(1, `${t.collectionItemTitle} Saved`, null, null); // Send Success Alert to Item
                    t.formMode = 'View'; // Change Form Mode
                } else {
                    t.MIX_alert(-1, `Error Saving ${t.collectionItemTitle}`, null, null); // Send Error Alert to Item
                }
            },

        },
        async mounted() {
            var t = this;
            var urlPath = window.location.pathname.split('/');
            t.form.id = urlPath[2];
            
            // console.log('id = ' + t.id)
            var itemResult = await t.MIX_readDocumentById(t.collection, t.form.id)
            if (itemResult.code === -1) {
                // Help Item Does Not Exist
                t.formMode = 'New';
            } else {
                // Help Item Exists
                t.formMode = 'View';
                t.form = itemResult.data

            }

        }

    };
</script>

<style scoped>
    .expandtofill {
        display: block !important; width: 100% !important; height: 100% !important;
        /* background: red !important;  */
    }
</style>